import { IconInfo } from './ContactUs.Interfaces';

interface Props {
    iconInfo: IconInfo;
    hasTopSeperatorLine: boolean;
    showIcon: boolean;
}

const ContactSubItem: React.FC<Props> = ({ iconInfo, hasTopSeperatorLine, showIcon }) => {

    const defaultIcon = 'icon-MSite--146 mirror-for-heb';
    const { Icon = defaultIcon, IconContent, IconTitle } = iconInfo;
    const displaySubItem = ((Icon && Icon !== defaultIcon) || IconTitle || IconContent);
    
    if (!displaySubItem) return null;

    return <>
        {
            hasTopSeperatorLine &&
            <div className="seperator"></div>
        }
        <div className="icon-container">

            <div className="same-line">
                {
                    showIcon &&
                    <i aria-hidden="true"
                        className={`${iconInfo.Icon || defaultIcon} icon txt-pallete-color`}
                    />
                }

                {
                    IconTitle ?
                        <h3
                            className="icon-title clamp"
                            dangerouslySetInnerHTML={{ __html: IconTitle }}>
                        </h3> :
                        <div
                            className="icon-description clamp"
                            dangerouslySetInnerHTML={{ __html: IconContent }}
                        />
                }

            </div>

            {
                (IconTitle && IconContent) &&

                <div className={`icon-description clamp ${showIcon? 'margin' : ''}`}
                    dangerouslySetInnerHTML={{ __html: IconContent }}
                />
            }

        </div>

    </>
}


export default ContactSubItem;